<script>
export default {
  props: {
    visibleNav: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<template>
  <div class="menu-icon" @click="$emit('click')">
    <img
      src="@/assets/icon-menu-close.svg"
      v-if="visibleNav"
    >
    <img
      src="@/assets/icon-menu-open.svg"
      v-else
    >
  </div>
</template>

<style lang="scss" scoped>
.menu-icon {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 11;
}
</style>



// WEBPACK FOOTER //
// src/components/view/menu-icon.vue